import { Fabric } from "./Fabric.tsx";

/**
 * زمینهٔ امضای لیبل مد (docs/DESIGN_SYSTEM.md، «جلوهٔ امضا»).
 *
 *   auth       ورود و قفل: نور فلزی آرام که فقط اینجا حرکت می‌کند.
 *   workspace  صفحه‌های داده: همان نور، **ساکن**. هیچ انیمیشن بی‌پایانی
 *              پشت عدد مالی نیست.
 *
 * ورود و قفل پارچهٔ خردلی WebGL هم دارند (Fabric.tsx)؛ بدون WebGL همان
 * گرادیان و transform می‌ماند. حالت عملکرد، کاهش شفافیت و کاهش حرکت
 * جلوه را کامل برمی‌دارند (glass.css).
 */
export function Backdrop({ variant }: { variant: "auth" | "workspace" }) {
  return <div className={`mesh mesh--${variant}`} aria-hidden="true">
    <i />
    <i />
    <i />
    {variant === "auth" ? <Fabric /> : null}
  </div>;
}
